export default __webpack_public_path__ + "static/media/skyship3.eda20a05.webp";